import { BaseService } from "./BaseService";
import {
  KillSwitchModule,
  KillSwitchState,
  ModuleAuditQuery,
  ModuleAuditResponse,
  ToggleModuleRequest,
} from "@/types/module-kill-switch";

class ModuleKillSwitchService extends BaseService {
  private basePath = "/admin/module-kill-switches";

  async getStates(): Promise<KillSwitchState[]> {
    return this.get<KillSwitchState[]>(this.basePath);
  }

  async toggle(
    module: KillSwitchModule,
    payload: ToggleModuleRequest,
    options?: { disableToast?: boolean },
  ): Promise<KillSwitchState> {
    return this.request<KillSwitchState>(`${this.basePath}/${module}`, {
      method: "PATCH",
      body: JSON.stringify(payload),
      disableToast: options?.disableToast,
    });
  }

  async getAudit(query: ModuleAuditQuery): Promise<ModuleAuditResponse> {
    return this.get<ModuleAuditResponse>(this.basePath + "/audit", query);
  }
}

export const moduleKillSwitchService = new ModuleKillSwitchService();
